module.exports = require("@splunk/themes/getTheme");